/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BilanCompetenceFichierGridDto
 */
export interface BilanCompetenceFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierGridDto
     */
    idbilanCompetenceFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof BilanCompetenceFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BilanCompetenceFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BilanCompetenceFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BilanCompetenceFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BilanCompetenceFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the BilanCompetenceFichierGridDto interface.
 */
export function instanceOfBilanCompetenceFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BilanCompetenceFichierGridDtoFromJSON(json: any): BilanCompetenceFichierGridDto {
    return BilanCompetenceFichierGridDtoFromJSONTyped(json, false);
}

export function BilanCompetenceFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BilanCompetenceFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idbilanCompetenceFichier': !exists(json, 'idbilanCompetenceFichier') ? undefined : json['idbilanCompetenceFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function BilanCompetenceFichierGridDtoToJSON(value?: BilanCompetenceFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idbilanCompetenceFichier': value.idbilanCompetenceFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

